module.exports = __webpack_public_path__ + "images/greco-7038a131a8491278402084afd73fb008.jpg";